import React from 'react';

function BarrasTable({ barras }) {
  // Totales (suma de columnas) — mismo calculo que las columnas total_*
  // del query AURUM (window function SUM OVER PARTITION).
  const totals = (barras || []).reduce(
    (acc, b) => {
      acc.gr_au += Number(b.gr_au) || 0;
      acc.gr_ag += Number(b.gr_ag) || 0;
      acc.peso_bruto += Number(b.peso_bruto_gr) || 0;
      return acc;
    },
    { gr_au: 0, gr_ag: 0, peso_bruto: 0 }
  );

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      <div className="bg-gold-500 text-white px-5 py-2.5 font-semibold text-sm">
        Detalle de Barras (AURUM)
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-gray-50 text-gray-500 text-xs uppercase">
              <th className="px-4 py-2 text-left">Barra IG</th>
              <th className="px-4 py-2 text-right">Gr AU</th>
              <th className="px-4 py-2 text-right">Ley AU</th>
              <th className="px-4 py-2 text-right">Gr AG</th>
              <th className="px-4 py-2 text-right">Ley AG</th>
              <th className="px-4 py-2 text-right">Peso Bruto (g)</th>
            </tr>
          </thead>
          <tbody>
            {barras.map((b, i) => (
              <tr key={i} className="border-t border-gray-100 hover:bg-gold-50 transition-colors">
                <td className="px-4 py-2 font-mono font-bold text-gold-700">{b.barra_ig}</td>
                <td className="px-4 py-2 text-right font-mono">{b.gr_au?.toFixed(2)}</td>
                <td className="px-4 py-2 text-right font-mono">{b.ley_au?.toFixed(2)}</td>
                <td className="px-4 py-2 text-right font-mono">{b.gr_ag?.toFixed(2)}</td>
                <td className="px-4 py-2 text-right font-mono">{b.ley_ag?.toFixed(2)}</td>
                <td className="px-4 py-2 text-right font-mono">{b.peso_bruto_gr?.toFixed(2)}</td>
              </tr>
            ))}
            <tr className="border-t-2 border-gold-500 bg-gold-50 font-semibold text-gold-800">
              <td className="px-4 py-2">TOTAL</td>
              <td className="px-4 py-2 text-right font-mono">{totals.gr_au.toFixed(2)}</td>
              <td className="px-4 py-2 text-right text-gray-400">—</td>
              <td className="px-4 py-2 text-right font-mono">{totals.gr_ag.toFixed(2)}</td>
              <td className="px-4 py-2 text-right text-gray-400">—</td>
              <td className="px-4 py-2 text-right font-mono">{totals.peso_bruto.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="px-5 py-2 text-xs text-gray-500">
        Totales: gramos finos de oro = <span className="font-mono">{totals.gr_au.toFixed(2)}</span>{' '}
        · gramos finos de plata = <span className="font-mono">{totals.gr_ag.toFixed(2)}</span>{' '}
        · peso bruto total = <span className="font-mono">{totals.peso_bruto.toFixed(2)}</span> g
      </div>
    </div>
  );
}

export default BarrasTable;
